import { render, staticRenderFns } from "./danhao.vue?vue&type=template&id=c0aac3fa&scoped=true"
import script from "./danhao.vue?vue&type=script&lang=js"
export * from "./danhao.vue?vue&type=script&lang=js"
import style0 from "./danhao.vue?vue&type=style&index=0&id=c0aac3fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aac3fa",
  null
  
)

export default component.exports